import 'css-chunksrc/client/pages/exportsPage/timesheetReport/styles.scss';export default {
  "wbsReport": "_wbsReport_1wlrg_1",
  "checked": "_checked_1wlrg_7",
  "row": "_row_1wlrg_11",
  "checkbox": "_checkbox_1wlrg_20",
  "col": "_col_1wlrg_26",
  "name": "_name_1wlrg_30",
  "description": "_description_1wlrg_37",
  "filters": "_filters_1wlrg_42",
  "group": "_group_1wlrg_51",
  "label": "_label_1wlrg_60",
  "button": "_button_1wlrg_67",
  "integrationDateFilterInput": "_integrationDateFilterInput_1wlrg_71",
  "integrationDateFilterTypeName": "_integrationDateFilterTypeName_1wlrg_78"
};